module.exports = __webpack_public_path__ + "img/nav_flex.8d4a2183.svg";